import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './yieldSummaryTableCompare.module.scss';
import { formatItalianNumber, formatItalianPercentageNo100 } from 'utils/formatUtils';
import { useComparisonLabels } from '../../../compare/ComparisonLabelsContext';

const YieldSummaryTableCompare = ({ dataObject, dataObject2 }) => {
  const { t } = useTranslation();
  const labels = useComparisonLabels();

  if (!dataObject) {
    return null;
  }

  const rows = [
    {
      label: t('portfolio.distribuzioneProventi'),
      portfolio1:
        dataObject.monthly_distribution != null ? formatItalianPercentageNo100(dataObject.monthly_distribution) : '-',
      portfolio2:
        dataObject2?.monthly_distribution != null
          ? formatItalianPercentageNo100(dataObject2.monthly_distribution)
          : '-',
    },
    {
      label: t('portfolio.yieldToMaturity'),
      portfolio1: dataObject.ytm_total != null ? formatItalianPercentageNo100(dataObject.ytm_total) : '-',
      portfolio2: dataObject2?.ytm_total != null ? formatItalianPercentageNo100(dataObject2.ytm_total) : '-',
    },
    {
      label: t('portfolio.durationAnni'),
      portfolio1: dataObject.duration_total != null ? formatItalianNumber(dataObject.duration_total) : '-',
      portfolio2: dataObject2?.duration_total != null ? formatItalianNumber(dataObject2.duration_total) : '-',
    },
  ];

  return (
    <div className={styles.tableContainer}>
      <table className={styles.compareTable}>
        <thead>
          <tr>
            <th></th>
            <th>{labels.portfolio1}</th>
            <th>{labels.portfolio2}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>{row.label}</td>
              <td>{row.portfolio1}</td>
              <td>{row.portfolio2}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default YieldSummaryTableCompare;
